;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:propstrata-app":true});}catch(e){}}();export const userQueryKeys = {
	all: ["user"] as const,
	communicationSources: (workspaceId: string) =>
		[...userQueryKeys.all, workspaceId, "communication-sources"] as const,
	dataProviders: (workspaceId: string) =>
		[...userQueryKeys.all, workspaceId, "data-providers"] as const,
	detail: (userId: string | undefined) =>
		[...userQueryKeys.all, userId] as const,
	privacy: () => [...userQueryKeys.all, "privacy"] as const,
	reportingSources: (workspaceId: string) =>
		[...userQueryKeys.all, workspaceId, "reporting-sources"] as const,
	settings: () => [...userQueryKeys.all, "settings"] as const,
};

export const userMutationKeys = {
	createDataProvider: (workspaceId: string) =>
		["user", "workspace", workspaceId, "create.data_provider"] as const,
	deleteDataProvider: (workspaceId: string) =>
		["user", "workspace", workspaceId, "delete.data_provider"] as const,
	editDataProvider: (workspaceId: string) =>
		["user", "workspace", workspaceId, "edit.data_provider"] as const,
	notificationPreferences: ["user", "notification.preferences"] as const,
	pingDataProvider: (workspaceId: string) =>
		["user", "workspace", workspaceId, "ping.data_provider"] as const,
	privacyUpdate: ["user", "privacy.update"] as const,
	update: ["user", "update"] as const,
};
